import { STORE_GETTER } from "../store/store";




export const categoryMixin = {

	computed: {

		baseCategoryModel() {
			return this.$store.getters[STORE_GETTER.CATEGORY_MODEL];
		},

		startCategoryGrid() {
			const categoryTree = this.baseCategoryModel?.categoryTree
			var categoryList = categoryTree?.categoryList?.filter(category => category !== null);
			return categoryList
		},

		cateogryIdImageList(){
			return [269, 664, 348, 349, 365, 347, 346, 366, 4, 9, 205, 92];
		},

		prouductCountList() {

			const productCountList = this.$store.getters[STORE_GETTER.CATEGORY_PRODUCT_COUNT_LIST];
			return productCountList;
		},

	},

	methods: {

		sortCategoryList(categoryList) {
			return categoryList?.filter(category => category != null).sort((a, b) => a.name?.localeCompare(b.name))
		},


		getProductTypeUrlKeyFromCategory(category){

			const rootCategoryId = category?.pathIdList[0]

			//alert(rootCategoryId);

			const mcList = [269, 4, 205, 92];
			const cykelList = [348, 349, 365, 347, 346, 366, 664];
			const oljaList = [9]



			if (mcList.includes(rootCategoryId)) {
				return "mc";

			} else if (cykelList.includes(rootCategoryId)) {
				return "cykel"

			} else if (oljaList.includes(rootCategoryId)) {
				return "olja"
			}

			return null;
		},

		parentCategoryImage(category){

			// loopa listan av parent id och se vilken som får en bild. 

			const pathIdList = category?.pathIdList?.filter(pathId => pathId != null);

			if (!pathIdList) return null;

			for (const pathId of [...pathIdList].reverse()) {
				if (this.cateogryIdImageList?.includes(pathId)) {
					return pathId;
				}
			}

		},

		prouductCountLabel(category) {

			const count = this.prouductCountList[category.categoryId];

			if (count && count > 0) {
				return count + ""
			}

			return null;

		},
		
		
}
}



